import PropTypes from 'prop-types';
import OutlineSectionContainer from './outlineSectionContainer';
import { flattenOutline } from '../../utils/outlineUtils';
import PanelHeader from '../sidebar/panelHeader/panelHeader';

export default function Outline({ outline }) {
  const flattenedOutline = flattenOutline(outline);
  return (
    <div className="sidebar-scroll-panel sidebar-panel-default-appearance">
      <PanelHeader title="Outline" />
      <div className="sidebar-scroll-panel-body">
        <ol className="branded u-font-serif u-display-block u-padding-s-right">
          {flattenedOutline.map((section, i) => (
            <OutlineSectionContainer
              dest={section.dest}
              title={section.title}
              /* eslint-disable-next-line react/no-array-index-key */
              key={i.toString()}
            />
          ))}
        </ol>
      </div>
    </div>
  );
}

Outline.propTypes = {
  outline: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string,
  })),
};

Outline.defaultProps = {
  outline: [],
};
